// extracted by mini-css-extract-plugin
export default {"root":"HHp_7","llama":"_3OjtV","big":"_2QDkb","small":"_2-wX5"};